document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  
  const popup = document.createElement('div');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--18616237981873__main');

const groupData = document.getElementById("selling-plan-groups-data");
let dropstreetPlans = [];

if (groupData) {
  const sellingPlanGroups = JSON.parse(groupData.textContent);

  // Filter by specific group name or ID
  const TARGET_GROUP_NAME = "Dropstreet Reminders"; // or use group.id
  const targetGroup = sellingPlanGroups.find(group => group.name === TARGET_GROUP_NAME);

  if (targetGroup) {
    dropstreetPlans = targetGroup.selling_plans;
    console.log("Selling Plans from group:", dropstreetPlans);
  } else {
    console.log("No matching selling plan group found.");
    return;
  }
}else{
  return;
  
}



  // Create popup content
  popup.id = 'custom-subscription-popup';
  popup.style = 'position:fixed; z-index:9999; top:0; left:0; width:100vw; height:100vh; background:rgba(0,0,0,0.6)';
  popup.innerHTML = `
   
    
  <div style="background:white; max-width:450px; margin:10% auto; padding:20px; border-radius:8px; text-align:center;">
    <p>Want a text reminder when it’s time to re-order?<br>
Just reply to the text to buy!<br><br>
                                      More details -> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></p>
    <label>Please choose reminder date:</label>
      <select id="subscription-plan-select">
        <option value="">-- Please select --</option>
        ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
      </select>
    <br><br>
    <label>Enter your cell phone number:</label>
    <input type="tel" id="subscription-phone" placeholder="e.g. 2345678900" style="padding:10px; width:100%; margin-bottom:10px;"  oninput="formatPhoneInput(this)"/>
    <div style="margin-top: 10px;">
      <button id="confirm-subscription" style="padding:10px 20px; margin-right:10px;">Sign Up</button>
      <button id="cancel-subscription" style="padding:10px 20px;">No Thanks</button>
    </div>
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>

  `;
  popup.style.display = 'none';
  document.body.appendChild(popup);

  // Intercept form submit
  let intercept = true;
  

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    const oneTimeRadio = document.querySelector('input[type="radio"][data-type="one_time"]');
  const hasAnyRadios = document.querySelectorAll('input[type="radio"][data-type]').length > 0;
    console.log ("hasAnyRadios "+ hasAnyRadios);
    const shouldShowPopup =
    intercept &&
    (
      (oneTimeRadio && oneTimeRadio.checked) || // Case 1: one-time radio is checked
      (!hasAnyRadios)                          // Case 2: no subscription radios at all
    );

  if (shouldShowPopup) {
    e.preventDefault();
    popup.style.display = 'block';
  }
  });

  
  // Handle Yes
function handleSubscriptionSubmission(addSubscriptionData) {
  // Optional subscription fields
  const selectedPlan = document.getElementById('subscription-plan-select')?.value;
  const phoneSub = document.getElementById('subscription-phone')?.value;

  if (addSubscriptionData) {
    if (!selectedPlan) {
      alert('Please select a subscription plan.');
      return;
    }

    if (!phoneSub) {
      alert('Please enter your phone number.');
      return;
    }else if (!validatePhone(phoneSub)){
      alert('Please enter valild phone number.');
      return;
    }

    // Add hidden fields only when subscription is being added
    const sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.value = selectedPlan;
    form.appendChild(sellingPlanInput);

    const phoneInput = document.createElement('input');
    phoneInput.type = 'hidden';
    phoneInput.name = 'properties[Phone Number]';
    phoneInput.value = formatPhoneNumber(phoneSub);
    form.appendChild(phoneInput);
  }

  // Hide popup and proceed
  popup.style.display = 'none';
  intercept = false;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
    .then(res => res.json())
    .then(() => {
      return new Promise(resolve => setTimeout(resolve, 200));
    })
    .then(() => {
      return fetch('/?sections=cart-drawer').then(res => res.json());
    })
    .then(sectionData => {
      const rawHTML = sectionData['cart-drawer'];
      if (!rawHTML) {
        console.warn('[CartDrawer] No cart-drawer section returned.');
        return;
      }

      // Parse new drawer
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = rawHTML;
      const newCartDrawer = tempDiv.querySelector('cart-drawer');
      if (!newCartDrawer) {
        console.warn('[CartDrawer] No <cart-drawer> in returned HTML.');
        return;
      }

      const currentCartDrawer = document.querySelector('cart-drawer');
      if (!currentCartDrawer) {
        console.warn('[CartDrawer] No <cart-drawer> in DOM.');
        return;
      }

      // Replace drawer content
      currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

      // Remove 'is-empty' if necessary
      if (currentCartDrawer.classList.contains('is-empty')) {
        currentCartDrawer.classList.remove('is-empty');
      }

      // Trigger drawer open
      const cartTrigger = document.querySelector('#cart-icon-bubble');
      if (cartTrigger) cartTrigger.click();

      console.log('[CartDrawer] Drawer updated and opened.');
    })
    .catch(err => {
      console.error("[CartDrawer] Error during cart update:", err);
    });
  intercept = true;
}

// Event bindings
document.getElementById('confirm-subscription').addEventListener('click', function () {
  handleSubscriptionSubmission(true); // Add subscription info
});

document.getElementById('cancel-subscription').addEventListener('click', function () {
  handleSubscriptionSubmission(false); // Skip subscription info
});


  
function formatPhoneNumber(phone) {
    phone = phone.trim(); // Remove leading/trailing spaces
   /* if (!phone.startsWith('+1')) {
        phone = '+1' + phone;
    }
    return phone;
*/
   // Remove all non-digit characters
  phone = phone.replace(/\D/g, '');

  // Limit to first 10 digits
  phone = phone.substring(0, 10);

  // Return formatted with +1 prefix
  return '+1' + phone;
  
}

  
});
/*
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer) {
    console.warn('Cart drawer not found');
    return;
  }

  const checkCartState = () => {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        console.log('[Cart Check] Cart item count:', cart.items.length);

        if (cart.items.length === 0) {
          console.log('[Cart Check] Cart is empty — adding is-empty class');
          console.log(cartDrawer);
          cartDrawer.classList.add('is-empty');
          console.log(cartDrawer);
        } else {
          console.log('[Cart Check] Cart has items — removing is-empty class');
          console.log(cartDrawer);
          cartDrawer.classList.remove('is-empty');
          console.log(cartDrawer);
        }
      })
      .catch((err) => {
        console.error('Error fetching cart data:', err);
      });
  };

  // Monitor DOM changes to the cart drawer content
  const cartItemsWrapper = cartDrawer.querySelector('[id^="CartDrawer-CartItems"]');

  if (!cartItemsWrapper) {
    console.warn('Cart drawer items container not found');
    return;
  }

  const observer = new MutationObserver(() => {
    console.log('[MutationObserver] Mutation detected. Re-checking cart state...');
    setTimeout(checkCartState, 100); // Delay to wait for theme to update classes
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });

  // Initial check
  checkCartState();
});

*/
/*
document.addEventListener('DOMContentLoaded', function () {
 
  const form = document.getElementById('product-form-template--17583153086658__main');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--17583153086658__main');

  const popup = document.getElementById('phonePopup');
  const phoneInput = document.getElementById('phoneInput');
  const phoneError = document.getElementById('phoneError');
  const popupYes = document.getElementById('popupYes');
  const popupNo = document.getElementById('popupNo');

  let submitMethod = null;

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    e.preventDefault(); // this is crucial
    if (popup.style.display !== 'block') {
      popup.style.display = 'block';
    }
  });

  // If user clicks NO – submit without custom field
  popupNo.addEventListener('click', function () {
    popup.style.display = 'none';
    form.submit(); // default Shopify submission
  });

  // If user clicks YES – validate phone, then add it as custom property and submit
  popupYes.addEventListener('click', function () {
    const phone = phoneInput.value.trim();
    if (!/^\+?\d{7,15}$/.test(phone)) {
      phoneError.style.display = 'block';
      return;
    }

    phoneError.style.display = 'none';

    // Inject the phone number as a custom property
    const propertyInput = document.createElement('input');
    propertyInput.type = 'hidden';
    propertyInput.name = 'properties[Phone Number]';
    propertyInput.value = phone;
    form.appendChild(propertyInput);

    popup.style.display = 'none';
    form.submit(); // proceed with form submission
  });
});
*/

/*
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('button.product-form__submit');

  // Replace this with your own check logic for subscription group
  const isSubscriptionProduct = () => {
    // Example condition: product has a specific selling plan group name or ID
    // You could check for presence of a hidden input or a class name
    return document.querySelector('[data-selling-plan-group-id="123456"]') !== null;
  };

  const showPopup = () => {
    document.getElementById('phone-popup').style.display = 'block';
  };

  const hidePopup = () => {
    document.getElementById('phone-popup').style.display = 'none';
  };

  const validatePhone = (phone) => {
    return /^\+?[0-9\s\-]{7,15}$/.test(phone);
  };

  addToCartBtn.addEventListener('click', function (e) {
    if (!isSubscriptionProduct()) return;

    e.preventDefault(); // Stop default add to cart behavior

    showPopup(); // Show custom phone popup
  });

  document.getElementById('popup-ok').addEventListener('click', function () {
    const phoneInput = document.getElementById('popup-phone');
    const errorMsg = document.getElementById('popup-error');
    const phoneValue = phoneInput.value.trim();

    if (!validatePhone(phoneValue)) {
      errorMsg.style.display = 'block';
      return;
    }

    errorMsg.style.display = 'none';

    // OPTIONAL: Store phone number in hidden input for form submission
    const hiddenPhone = document.createElement('input');
    hiddenPhone.type = 'hidden';
    hiddenPhone.name = 'properties[Phone Number]';
    hiddenPhone.value = phoneValue;
    document.querySelector('form').appendChild(hiddenPhone);

    hidePopup();

    // Submit the form programmatically
    addToCartBtn.closest('form').submit();
  });
});
*/